/*
 * @Author: MWeiLiu
 * @Date: 2019-12-17 20:12:04
 * @Last Modified by: MWeiLiu
 * @Last Modified time: 2019-12-18 14:27:28
 */

// 404
const notFind = resolve => {
  require.ensure([], () => {
    resolve(require('@/views/notFind/notFind.vue'))
  }, 'notFind')
}

// 首页
const index = resolve => {
  require.ensure([], () => {
    resolve(require('@/views/index/index.vue'))
  }, 'index')
}

// 藏品文库信息
const information = resolve => {
  require.ensure([], () => {
    resolve(require('@/views/information/information.vue'))
  }, 'information')
}

// 藏品文库信息详情
const informationcon = resolve => {
  require.ensure([], () => {
    resolve(require('@/views/informationcon/informationcon.vue'))
  }, 'informationcon')
}

// 无机质藏品文库信息
const inorganic = resolve => {
  require.ensure([], () => {
    resolve(require('@/views/inorganic/inorganic.vue'))
  }, 'inorganic')
}

// 数字精品
const boutique = resolve => {
  require.ensure([], () => {
    resolve(require('@/views/boutique/boutique.vue'))
  }, 'boutique')
}

// 数字精品详情
const boutiquecon = resolve => {
  require.ensure([], () => {
    resolve(require('@/views/boutiquecon/boutiquecon.vue'))
  }, 'boutiquecon')
}

// 藏品统计
const statistics = resolve => {
  require.ensure([], () => {
    resolve(require('@/views/statistics/statistics.vue'))
  }, 'statistics')
}

// h5首页
const mindex = resolve => {
  require.ensure([], () => {
    resolve(require('@/views/m/index/index.vue'))
  }, 'mindex')
}

// h5藏品文库信息
const minformation = resolve => {
  require.ensure([], () => {
    resolve(require('@/views/m/information/information.vue'))
  }, 'minformation')
}

// h5无机质藏品文库信息
const minorganic = resolve => {
  require.ensure([], () => {
    resolve(require('@/views/m/inorganic/inorganic.vue'))
  }, 'minorganic')
}

// h5藏品文库信息详情
const minformationcon = resolve => {
  require.ensure([], () => {
    resolve(require('@/views/m/informationcon/informationcon.vue'))
  }, 'minformationcon')
}

// h5数字精品
const mboutique = resolve => {
  require.ensure([], () => {
    resolve(require('@/views/m/boutique/boutique.vue'))
  }, 'mboutique')
}

// 数字精品详情
const boutiquecon1 = resolve => {
  require.ensure([], () => {
    resolve(require('@/views/boutiquecon1/boutiquecon.vue'))
  }, 'boutiquecon1')
}

// hs数字精品详情
const mboutiquecon = resolve => {
  require.ensure([], () => {
    resolve(require('@/views/m/boutiquecon/boutiquecon.vue'))
  }, 'mboutiquecon')
}

// hs数字精品详情
const mboutiquecon1 = resolve => {
  require.ensure([], () => {
    resolve(require('@/views/m/boutiquecon1/boutiquecon.vue'))
  }, 'mboutiquecon1')
}

// 藏品统计
const mstatistics = resolve => {
  require.ensure([], () => {
    resolve(require('@/views/m/statistics/statistics.vue'))
  }, 'mstatistics')
}

export default {
  notFind,
  index,
  information,
  informationcon,
  inorganic,
  boutique,
  boutiquecon,
  statistics,
  mindex,
  minformation,
  minorganic,
  minformationcon,
  mboutique,
  mboutiquecon,
  mboutiquecon1,
  boutiquecon1,
  mstatistics
}



// WEBPACK FOOTER //
// ./src/router/fileLoad.js